/**
 * Created by mh on 2017/5/28.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import AssetModel from './model/AssetModel';
import AssetVisualPreview from './AssetVisualPreview';

import { MdMusicNote, MdImage, MdVideoLibrary, MdReportProblem } from 'react-icons/md';

const TypeToColorClass = (type) => {
    switch (type) {
    case 'audio':
        return 'badge-primary';
    case 'video':
        return 'badge-info';
    default:
        return 'badge-secondary';
    }
};

// TODO generalize
const TypeToIcon = (type) => {
    switch (type) {
    case 'video':
        // TODO change to single video
        return <MdVideoLibrary />;
    case 'audio':
        return <MdMusicNote />;
    case 'still':
        return <MdImage />;
    default:
        return <MdReportProblem />;
    }
};

const TypeBadge = type => <span className={`badge ${TypeToColorClass(type)}`}>{TypeToIcon(type)} {type}</span>;

const BuildedColumns = ({ asset, columns }) => columns.map((column, index) => (
    <td className="align-middle" key={index}>
        {column.type === 'thumbnail' ? (
            <Link className="" to={`/assets/details/${asset.id}/`}>
                <AssetVisualPreview asset={asset} previewStill width={column.size ? column.size : 80} />
            </Link>) : null}
        {column.type === 'type' ? TypeBadge(asset.type) : null}
        {column.type === 'metadata' ? asset.getDataFromLocation(column.location) : null}
    </td>));

// <Link className="" to={`/assets/details/${asset.id}/`}>
//    {asset.name}
// </Link>
// <button className="btn btn-sm btn-danger" onClick={this.deleteAsset}>Delete</button>

@observer
export default class AssetTableRow extends React.Component {
    deleteAsset = () => {
        this.props.assets.deleteAsset(this.props.asset.id);
    };

    render() {
        const { asset, columns } = this.props;

        return (
            <tr>
                <BuildedColumns asset={asset} columns={columns} />
                <td className="align-middle">
                    <Link className="btn btn-sm btn-secondary" to={`/assets/details/${asset.id}/`}>+</Link>
                </td>
            </tr>);
    }
}
AssetTableRow.propTypes = {
    columns: PropTypes.array.isRequired,
    asset: PropTypes.instanceOf(AssetModel).isRequired,
};
